// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95df8c48","455":"55372804","895":"4db51e81","977":"240addac"}[chunkId] + ".chunk.js";
};